__turbopack_context__.v({
  "hasSubmitted": "ContactForm-module__yGOxyW__hasSubmitted",
  "inputWrapper": "ContactForm-module__yGOxyW__inputWrapper",
  "root": "ContactForm-module__yGOxyW__root",
  "submittedMessage": "ContactForm-module__yGOxyW__submittedMessage",
});
